module.exports = __webpack_public_path__ + "img/punho-fechado.0062e61b.svg";